import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

// merge tailwind classes
const cn = (...inputs: ClassValue[]): string => {
  return twMerge(clsx(inputs));
};

export { cn };
